<template>
  <GetFilesWizardComponent :device="curDevice" />
</template>

<script lang="ts">
import { IDevice } from "@/common/api/unifiedPortal/interfaces";
import { useRouter } from "vue-router";
import GetFilesWizardComponent from "@/components/Backup/GetFilesWizard.vue";
import { defineComponent, ref } from "vue";
import { useUserStore } from "@/stores/user";

const componentName = "GetFilesRoute";

export default defineComponent({
  name: componentName,
  components: { GetFilesWizardComponent },
  setup() {
    const router = useRouter();
    const userStore = useUserStore();

    const q = router.currentRoute.value.query;
    const deviceId = parseInt((q.deviceId || q.deviceid) as string);
    const device = userStore?.userDetails?.devices.find(d => d.deviceId == deviceId);
    const curDevice = ref<IDevice | undefined>(device);

    return { curDevice };
  },
});
</script>
